/**
 * Stop-Go lamp - three chambers for directions, third chamber is for stop, second chamber for right, left, first chamber for straight
 * - used in Charleroi
 * - needs to be adjusted for different cities when needed
 */

import Color from '../color.es6'
import Ren from '../ren-shape.es6'
import Element from './element.es6'

export default class MelSgThreeChambersDirection extends Element {
  setDefaultShapes () {
    this.shapes.push(
      new Ren.Rect({
        name: '',
        x: 0,
        y: 0,
        width: 30,
        height: 30,
        strokeWidth: 0.5,
        fill: Color.offlineGray,
        opacity: 0.8
      }),

      new Ren.Circle({
        name: 'circle',
        x: 15,
        y: 15,
        radius: 15,
        fill: Color.offlineGray
      }),

      new Ren.Rect({
        name: '',
        x: 0,
        y: 30,
        width: 30,
        height: 30,
        strokeWidth: 0.5,
        fill: Color.offlineGray,
        opacity: 0.8
      }),

      new Ren.Circle({
        name: 'circle',
        x: 15,
        y: 45,
        radius: 15,
        fill: Color.offlineGray
      }),

      new Ren.Rect({
        name: '',
        x: 0,
        y: 60,
        width: 30,
        height: 30,
        strokeWidth: 0.5,
        fill: Color.offlineGray,
        opacity: 0.8
      }),

      new Ren.Circle({
        name: 'circle',
        x: 15,
        y: 75,
        radius: 15,
        fill: Color.offlineGray
      }),

      new Ren.Line({
        name: 'right',
        points: [5, 85, 25, 65],
        stroke: 'white',
        strokeEnabled: true,
        strokeWidth: 2,
        visible: false
      }),

      new Ren.Line({
        name: 'left',
        points: [5, 65, 25, 85],
        stroke: 'white',
        strokeEnabled: true,
        strokeWidth: 2,
        visible: false
      }),

      new Ren.Line({
        name: 'straight',
        points: [15, 33, 15, 57],
        stroke: 'white',
        strokeEnabled: true,
        strokeWidth: 2,
        visible: false
      }),

      new Ren.Line({
        name: 'stop',
        points: [3, 15, 27, 15],
        stroke: 'white',
        strokeEnabled: true,
        strokeWidth: 2,
        visible: false
      }),

      // signalling foor
      new Ren.Line({
        points: [15, 90, 15, 110],
        strokeWidth: 2,
        opacity: 0.8
      }),

      new Ren.Line({
        points: [0, 110, 30, 110],
        strokeWidth: 2,
        opacity: 0.8
      })
    )
  }

  turnOffAll () {
    this.modifyShape('straight', 'visible', false)
    this.modifyShape('left', 'visible', false)
    this.modifyShape('right', 'visible', false)
    this.modifyShape('stop', 'visible', false)
  }

  applyStatusOnShapes (newVariables, deviceTypes) {
    const status = newVariables || this.status
    super.applyStatusOnShapes(status)

    if (status.signalStop === 1) {
      this.turnOffAll()
      this.modifyShape('stop', 'visible', true)
    } else if (status.signalGoStraight === 1) {
      this.turnOffAll()
      this.modifyShape('straight', 'visible', true)
    } else if (status.signalGoLeft === 1) {
      this.turnOffAll()
      this.modifyShape('left', 'visible', true)
    } else if (status.signalGoRight === 1) {
      this.turnOffAll()
      this.modifyShape('right', 'visible', true)
    } else {
      this.turnOffAll()
    }
  }
}
